import { render, staticRenderFns } from "./NumberController.vue?vue&type=template&id=fdd527f0&scoped=true&"
import script from "./NumberController.vue?vue&type=script&lang=js&"
export * from "./NumberController.vue?vue&type=script&lang=js&"
import style0 from "./NumberController.vue?vue&type=style&index=0&id=fdd527f0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdd527f0",
  null
  
)

export default component.exports